<template>
  <div class="wd-w-[30%] wd-text-center wd-flex-col wd-flex wd-items-center">
    <div
      class="wd-w-8 wd-h-8 wd-mb-3 wd-flex wd-justify-center wd-items-center wd-border wd-rounded-full"
      :class="[active ? 'wd-bg-orange50' : cancel ? 'wd-bg-orange30' : 'wd-bg-gray40']"
    >
      <FunnowSvgIcon v-if="icon" max-width="24" :image-path="icon" color="white" />
      <span v-else class="wd-text-gray80">{{ sno }}</span>
    </div>

    <span class="wd-text-osm" :class="[icon ? 'wd-text-orange50' : 'wd-text-gray80']">{{ text }}</span>
  </div>
</template>

<script>
import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'

export default defineComponent({
  components: {
    FunnowSvgIcon,
  },
  props: {
    active: { type: Boolean, default: false },
    cancel: { type: Boolean, default: false },
    icon: { type: String, default: '' },
    text: { type: String, default: '' },
    sno: { type: [Number, String], default: 2 },
  },
  setup() {
    return {}
  },
})
</script>
